import { observable, runInAction } from "mobx"

import { fetchGetCoursesById } from "~/api/courses/[id]/get"
import { Course } from "~/entities/Course"

export default class CourseStore {
  @observable course: Course | null = null

  fetchById = async (id: number): Promise<Course | null> => {
    const res = await fetchGetCoursesById(id)
    runInAction(() => {
      this.course = new Course(res)
    })
    return this.course
  }
}
